import { render, staticRenderFns } from "./ECommerceShop.vue?vue&type=template&id=45de9b34&"
import script from "./ECommerceShop.vue?vue&type=script&lang=js&"
export * from "./ECommerceShop.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceShop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports